import React from 'react';
import { CategoryResponse } from '../../../../types/api/categories';
import { Stack, Text } from '@primer/react'

interface CategorySelectViewProps {
    category: CategoryResponse;
    onCategoryClick: () => void;
}

export const CategorySelectView: React.FC<CategorySelectViewProps> = ({ category, onCategoryClick }) => {
    const categoryImage = category.image?.preview ?? category.image?.file;

    return (
        <div className='h-[33px] w-full ml-[40px]'>
            <Stack direction="horizontal" align="center" className='w-full'>
                <div
                    style={{
                        backgroundImage: `url("${categoryImage}")`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        width: "20px",
                        height: "20px",
                        minWidth: "20px",
                        minHeight: "20px",
                        borderRadius: "50%",
                        flexShrink: 0
                    }}
                />
                <div className="flex items-center w-full gap-4 overflow-hidden">
                    <div className="flex flex-col min-w-0">
                        <div
                            onClick={onCategoryClick}
                            className="flex items-center h-[20px] cursor-pointer">
                            <Text
                                className='truncate'
                                fontSize='14'
                                fontWeight="semibold"
                                color="fg.default">
                                {category.title}
                            </Text>
                            <Text fontSize={14} color="fg.default" display="block" className="ml-2">
                                {category.catalogsCount} подразделов
                            </Text>
                        </div>
                    </div>
                </div>
            </Stack>
        </div>
    );
};